<template>
  <b-modal id="modal-filters" title="Property Filters">
    <div v-for="(filter, key) in localFilters" :key="key" class="mb-3">
      <template v-if="filter.type && filter.type == 'date'">
        <b-form-group>
          <template #label>
            <div class="d-block font-weight-bold">{{ filter.label }}</div>
          </template>
          <b-row>
            <b-col>
              <div :for="`${key}-min`" class="d-block text-muted small mb-1">
                Min
              </div>
              <b-form-datepicker
                class="filter-input"
                :id="`${key}-min`"
                v-model="filter.value.min"
                reset-button
                close-button
                size="md"
                @input="emitFilters"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <div :for="`${key}-max`" class="d-block text-muted small mb-1">
                Max
              </div>
              <b-form-datepicker
                class="filter-input"
                :id="`${key}-max`"
                reset-button
                close-button
                v-model="filter.value.max"
                size="md"
                @input="emitFilters"
              ></b-form-datepicker>
            </b-col>
          </b-row>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group>
          <template #label>
            <div class="d-block font-weight-bold">{{ filter.label }}</div>
          </template>
          <b-row>
            <b-col>
              <div :for="`${key}-min`" class="d-block text-muted small mb-1">
                Min
              </div>
              <b-form-input
                class="filter-input"
                :id="`${key}-min`"
                v-model.number="filter.value.min"
                type="number"
                size="md"
                @input="emitFilters"
              ></b-form-input>
            </b-col>
            <b-col>
              <div :for="`${key}-max`" class="d-block text-muted small mb-1">
                Max
              </div>
              <b-form-input
                class="filter-input"
                :id="`${key}-max`"
                v-model.number="filter.value.max"
                type="number"
                size="md"
                @input="emitFilters"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
      </template>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <!-- <b-button variant="outline-vb-red" size="sm" class="float-right" @click="hideModal">
          Close
        </b-button> -->
        <b-button
          variant="vb-purple"
          size="sm"
          class="float-left"
          @click="resetFilters"
        >
          Reset Filters
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      localFilters: {},
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.localFilters = JSON.parse(JSON.stringify(newValue));
      },
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("modal-filters");
    },
    emitFilters() {
      this.$emit("input", this.localFilters);
    },
    resetFilters() {
      this.$emit("reset-filter");
    },
  },
};
</script>

<style scoped>
.filter-input {
  border: 2px solid #d4d4d4;
  border-radius: 10px !important;
  background: #f3f3f3;
}
</style>
